import { useState } from "react";
import type { FaqItem } from "@/types/content";

export default function FaqAccordion({ items }: { items: FaqItem[] }) {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <div className="flex flex-col gap-3">
      {items.map((item, index) => {
        const isOpen = openIndex === index;
        return (
          <div
            key={item.question}
            className={`rounded-2xl border transition-colors ${
              isOpen
                ? "bg-background-50 border-primary-200"
                : "bg-background-100 border-background-200"
            }`}
          >
            <button
              type="button"
              onClick={() => setOpenIndex(isOpen ? null : index)}
              aria-expanded={isOpen}
              className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left"
            >
              <span className="flex items-start gap-3">
                <span className="w-6 h-6 rounded-md bg-primary-100 text-primary-700 text-xs font-bold flex items-center justify-center shrink-0 mt-0.5">
                  {index + 1}
                </span>
                <span className="text-sm md:text-base font-bold text-foreground-950">
                  {item.question}
                </span>
              </span>
              <span className="w-7 h-7 rounded-full bg-background-200 text-foreground-700 flex items-center justify-center shrink-0">
                <i className={isOpen ? "ri-subtract-line" : "ri-add-line"}></i>
              </span>
            </button>
            {isOpen && (
              <div className="px-5 pb-5 pl-14">
                <p className="text-sm leading-relaxed text-foreground-600">{item.answer}</p>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}